export const portalLanguages: { code: string; label: string }[] = [
  { code: 'ro', label: 'RO' },
  { code: 'ru', label: 'RU' },
  { code: 'en', label: 'EN' },
  { code: 'pl', label: 'PL' },
  { code: 'es-MX', label: 'ES' },
  { code: 'hu', label: 'HU' },
];
